module.exports = __webpack_public_path__ + "static/media/archrete video.c9e48b0e.mp4";